import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watch, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { AuthGetters } from "@/store/modules/auth";
import { accountKey } from "@/utils/accountSession";
import { canUseDarkTheme, syncTheme, themeStorageKey } from "@/utils/theme";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const identity = computed(() => store.getters[AuthGetters.GET_USER_IDENTITY]);
watch(() => [accountKey(identity.value || null), canUseDarkTheme(identity.value)], () => syncTheme(identity.value), { immediate: true, flush: "sync" });
function onThemeStorage(event: StorageEvent) {
  if (event.key === null || event.key === themeStorageKey(identity.value)) syncTheme(identity.value);
}
onMounted(() => window.addEventListener("storage", onThemeStorage));
onBeforeUnmount(() => window.removeEventListener("storage", onThemeStorage));

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})